import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FieldMap } from 'src/app/interfaces/stellar-cartography.interfaces';
import { ScanMap } from 'src/app/interfaces/scan.interfaces';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-starmap',
  templateUrl: './starmap.component.html',
  styleUrls: ['./starmap.component.css']
})
export class StarmapComponent implements OnInit {
  @Input() center: { x: number; y: number; r: number } = { x: 257, y: 18, r: 10 };
  @Input() fields: FieldMap = {};
  @Input() scans: ScanMap = {};
  @Output() mapClick = new EventEmitter<{ x: number; y: number }>();

  xRange: number[] = [];
  yRange: number[] = [];
  imageUrl = environment.imageUrl;

  constructor() { }

  ngOnInit(): void {
    this.generateRanges();
  }

  ngOnChanges(): void {
    this.generateRanges();
  }

  generateRanges() {
    this.xRange = [];
    for (let x = this.center.x - this.center.r; x <= this.center.x + this.center.r; x++) {
      this.xRange.push(x);
    }
    this.yRange = [];
    for (let y = this.center.y - this.center.r; y <= this.center.y + this.center.r; y++) {
      this.yRange.push(y);
    }
  }

  onCellClick(x: number, y: number) {
    this.mapClick.emit({ x, y });
  }

  getField(x: number, y: number) {
    return this.fields[y] ? this.fields[y][x] : null;
  }

  getScanCount(x: number, y: number) {
    if (this.scans[y] && this.scans[y][x]) {
      const scanObjectCount = this.scans[y][x].scanObjects.length;
      return scanObjectCount > 0 ? scanObjectCount : '';
    }
    return '';
  }

  getFieldTitle(x: number, y: number) {
    const field = this.getField(x, y);
    if (!field) return `${x}|${y}`;
    let title = `${x}|${y} - Weltraum`;
    for (const special of field.specials) {
      title += ' - ' + special;
    }
    if (field.signatureCount) {
      title += ` - ${field.signatureCount} Signaturen`;
    }
    if (field.iconianSignatureCount) {
      title += ` - ${field.iconianSignatureCount} Iconia-Signaturen`;
    }
    return title;
  }

  getFieldContent(x: number, y: number) {
    const field = this.getField(x, y);
    if (
      field?.signatureCount !== undefined ||
      field?.iconianSignatureCount !== undefined
    ) {
      const signatureCount = field.signatureCount || 0;
      const iconianSignatureCount = field.iconianSignatureCount || 0;
      if (signatureCount > 0 && iconianSignatureCount > 0) {
        return `${signatureCount}/${iconianSignatureCount}I`;
      }
      if (signatureCount > 0) {
        return signatureCount;
      }
      if (iconianSignatureCount > 0) {
        return `${iconianSignatureCount}I`;
      }
      return '';
    }
    return this.getScanCount(x, y);
  }

  getFieldColor(x: number, y: number) {
    if (x === this.center.x && y === this.center.y) {
      return '#666666';
    }
    const field = this.getField(x, y);
    return field ? `#${field.color}` : 'transparent';
  }
}
